import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M17.5 7q.563 0 1.031.458.47.459.469 1.042v1.187a1.35 1.35 0 0 1-.125.584l-2.48 5.812q-.165.417-.54.667-.376.25-.855.25H7q-.625 0-1.062-.427A1.44 1.44 0 0 1 5.5 15.5V7.625q0-.312.125-.594.125-.28.333-.49l4.188-4.187q.375-.375.916-.479.542-.105.917.125.48.27.615.792.135.52.031 1.02L12 7zm-15 10a1.44 1.44 0 0 1-1.052-.448A1.44 1.44 0 0 1 1 15.5v-7q0-.605.448-1.052A1.44 1.44 0 0 1 2.5 7q.604 0 1.052.448T4 8.5v7q0 .604-.448 1.052A1.44 1.44 0 0 1 2.5 17" }, null, -1)
  ]))]))
}
export default { render: render }